<div class="flex h-screen justify-center bg-evenlightergrey px-6 pb-6">
    <div class="w-full max-w-lg pt-8">
        <h1 class="text-center">Sign In</h1>
        <form [formGroup]="loginForm">
            <app-custom-input
                [control]="loginForm.controls.email"
                placeholder="Email"
                type="email"
                required="true"
                formControlName="email"
                label="Email">
            </app-custom-input>
            <app-custom-input
                [control]="loginForm.controls.password"
                placeholder="Password"
                type="password"
                required="true"
                formControlName="password"
                label="Password">
            </app-custom-input>
            @if (loginError(); as errorMessage) {
                <div class="mt-1 text-sm font-bold">
                    {{ errorMessage }}
                </div>
            }
            <app-save-button
                testId="checkoutRegisterButton"
                class="w-full"
                [showLoader]="isSubmittingForm()"
                (onClick)="onSubmit()"
                type="button"
                [additionalClasses]="['p-4 w-full mt-4 mb-2']">
                <span class="text-xl font-bold">Log in</span>
            </app-save-button>

            <app-link
                [link]="'/forgot-password'"
                [additionalClasses]="['underline text-sm hover:text-grey']">
                Forgot your password?
            </app-link>
        </form>

        <p class="mt-10 mb-5 text-center">Don't have an account yet?</p>
        <app-cta-button
            [link]="['/create-an-account']"
            variant="secondary"
            [additionalClasses]="[' w-full']"
            >Sign Up</app-cta-button
        >
    </div>
</div>
